module.exports = __webpack_public_path__ + "img/default.6d6916f.png";